/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, DatePicker, message, Drawer, Form } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import EquipmentSelect from '../../../components/Custom/EquipmentSelect'
import ConstituentSelect from '../../../components/Custom/ConstituentSelect'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedEquipment: null,
			didSelectEquipmentLookup: false,
			selectedConstituent: null,
			didSelectConstituent: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
		this.disabledDate = this.disabledDate.bind(this)
	}

	componentDidMount() {
		const { selectedBorrowedEquipment } = this.props
		if (selectedBorrowedEquipment) {
			this.setState({ 
				selectedEquipment: { 
					uid: selectedBorrowedEquipment.equipments_lookup_uid,
					didSelectEquipmentLookup: false 
				},
				selectedConstituent: {
					uid: selectedBorrowedEquipment.constituent_uid,
					didSelectConstituent: false
				}
			})
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { selectedEquipment, selectedConstituent, didSelectConstituent } = this.state
		const { form, AuthStore, saveBorrowEquipment, onClose, selectedBorrowedEquipment } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		console.log('didSelectConstituent', didSelectConstituent)
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
			const date_borrowed = moment(values.date_borrowed).format('YYYY-MM-DD HH:mm:ss')
			const date_returned = values.date_returned ? moment(values.date_returned).format('YYYY-MM-DD HH:mm:ss') : null
			let params = Object.assign({}, values, { 
				barangay_uid, date_borrowed, date_returned,
				equipments_lookup_uid: selectedEquipment.uid,
				constituent_uid: selectedConstituent.uid,
				constituent_name: selectedConstituent.didSelectConstituent ? `${selectedConstituent.first_name} ${selectedConstituent.last_name}` : selectedBorrowedEquipment.constituent_name
			})
			if (selectedBorrowedEquipment) {
				params = Object.assign({}, params, { equipment_uid: selectedBorrowedEquipment.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_equipment', content: 'Saving equipment, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveBorrowEquipment(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_equipment', content: 'Equipment successfully saved.' })

					//create audit trail
					const auditParams = {
						module_name: 'Management',
						action: (selectedBorrowedEquipment) ? 'Update' : 'Create',
						message: (selectedBorrowedEquipment) ? 
							'Update record monitoring' : 
							'Created record for equipment monitoring'
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving equipment')
					message.error({ key: 'set_equipment', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	disabledDate (value) {
		return value < moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')
		// return value < moment(new Date(), 'YYYY-MM-DD')
	}

	render() {
		const { 
			AuthStore, visible, onClose, form, selectedBorrowedEquipment
		} = this.props
		const { getFieldDecorator } = form
		const { barangay_uid } = AuthStore
		
		return (
			<Drawer
				title="Equipment Form"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'35%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Form.Item label='Equipment'>
							{ getFieldDecorator('equipments_lookup_uid', {
								initialValue: (selectedBorrowedEquipment) ? selectedBorrowedEquipment.equipments_lookup_uid : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<EquipmentSelect 
									barangay_uid={barangay_uid} 
									onSelectedItem={(item) => {
										this.setState({ selectedEquipment: Object.assign({}, item, { didSelectEquipmentLookup: true }) })
									}}
								/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Borrower'>
							{ getFieldDecorator('constituent_uid', {
								initialValue: (selectedBorrowedEquipment) ? selectedBorrowedEquipment.constituent_name : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<ConstituentSelect 
									barangay_uid={barangay_uid} 
									onSelectedItem={(item) => {
										this.setState({ selectedConstituent: Object.assign({}, item, { didSelectConstituent: true }) })
									}}
								/>
							)}
						</Form.Item>
					</Row>
					<Row gutter={16}>
						<Col md={12} sm={24}>
							<Form.Item label='Date Borrowed'>
								{ getFieldDecorator('date_borrowed', {
									initialValue: (selectedBorrowedEquipment) ? 
										moment(new Date(selectedBorrowedEquipment.date_borrowed)) : 
									    moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker 
										showTime
										format='lll'
										style={{ width: '100%' }}
										disabledDate={this.disabledDate}
									/>
								)}
							</Form.Item>
						</Col>
						{
							selectedBorrowedEquipment &&
							<Col md={12} sm={24}>
								<Form.Item label='Date Returned'>
									{ getFieldDecorator('date_returned', {
										initialValue: (!selectedBorrowedEquipment) ? 
											moment(new Date(selectedBorrowedEquipment.date_returned)) : 
											moment(new Date()),
										rules: [{
											required: false,
											message: 'This field is required.'
										}]
									})
									(
										<DatePicker 
											showTime
											format='lll'
											style={{ width: '100%' }}
											disabledDate={this.disabledDate}
										/>
									)}
								</Form.Item>
							</Col>
						}
					</Row>
					<Row>
						<Form.Item label='Remarks'>
							{ getFieldDecorator('remarks', {
								initialValue: (selectedBorrowedEquipment) ? selectedBorrowedEquipment.remarks : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input.TextArea rows={4} placeholder='Enter Remarks'/>
							)}
						</Form.Item>
					</Row>
					{/* <Row>
						<Form.Item label='Select Date of Reservation'>
							{ getFieldDecorator('event_range', {
								initialValue: (!selectedEquipment && selectedDate) ? 
								    [moment(new Date(selectedDate), dateFormat), moment(new Date(selectedDate), dateFormat)] : 
								    [moment(new Date(selectedEquipment.from_date), dateFormat), moment(new Date(selectedEquipment.to_date), dateFormat)],
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<RangePicker 
									showTime
									format={dateFormat}
									separator='to'
									style={{ width: '100%' }}
									disabledDate={this.disabledDate}
								/>
							)}
						</Form.Item>
					</Row> */}
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_BORROWED_EQUIPMENT = gql`
    mutation setBorrowedEquipment($input: JSON) {
		setBorrowedEquipment(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-equipments' }),
	inject('AuthStore'),
	graphql(SET_BORROWED_EQUIPMENT, {
		props({ mutate }) {
			return {
				saveBorrowEquipment(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allBorrowedEquipments']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
